<template>
  <div class="home">
    <HeaderStyle1>
<!--      <h1 slot="title" v-html="$t('home-head-h1')"></h1>-->
<!--      <p slot="detail" v-html="$t('home-head-small')"></p>-->
<!--      <b-img slot="image" src="../assets/imgs/banner_img_home.jpg" alt="" />-->
<!--      <b-img slot="banner" class="banner" src="../assets/imgs/banner_img_home.jpg" alt="" />-->
    </HeaderStyle1>

    <main class="main-content">
      <b-container fluid="xl" class="section-1">
<!--        <h2 class="section-title">{{$t('section-title-1')}}</h2>-->
<!--        <h3 class="section-sub-title">{{$t('section-sub-title-1')}}</h3>-->

<!--        <b-row class="mt-5">-->
<!--          <b-col class="p-4" cols="12" xl="4" md="4" sm="12">-->
<!--            <b-img class="image-app-logo" src="../assets/imgs/icon_healthStep_logo.png" fluid alt=""></b-img>-->
<!--            <span class="image-title">{{$t('section-1-img-1-title')}}</span>-->
<!--          </b-col>-->
<!--        </b-row>-->

        <h2 class="section-title">{{$t('section-title-study')}}</h2>
        <h3 class="section-sub-title">{{$t('section-sub-title-study')}}</h3>

        <b-row class="mt-5">
          <b-col class="p-4" cols="12" xl="4" md="4" sm="12">
            <b-img class="image-app-logo" src="../assets/imgs/icon_pedometer.png" fluid alt=""></b-img>
            <span class="image-title">{{$t('section-sub-title-study—idiom')}}</span>
          </b-col>
          <b-col class="p-4" cols="12" xl="4" md="4" sm="12">
            <b-img class="image-app-logo" src="../assets/imgs/icon_getup_logo.png" fluid alt=""></b-img>
            <span class="image-title">天天早起打卡（指尖早起打卡）</span>
          </b-col>
          <b-col class="p-4" cols="12" xl="4" md="4" sm="12">
            <b-img class="image-app-logo" src="../assets/imgs/icon_sheep_logo.png" fluid alt=""></b-img>
            <span class="image-title">天天早睡打卡</span>
          </b-col>
          <b-col class="p-4" cols="12" xl="4" md="4" sm="12">
            <b-img class="image-app-logo" src="../assets/imgs/icon_water_logo.png" fluid alt=""></b-img>
            <span class="image-title">每日喝水提醒（指尖喝水提醒）</span>
          </b-col>
          <b-col class="p-4" cols="12" xl="4" md="4" sm="12">
            <b-img class="image-app-logo" src="../assets/imgs/icon_happy_logo.png" fluid alt=""></b-img>
            <span class="image-title">开心计步（健身有宝|健身训练）</span>
          </b-col>
          <b-col class="p-4" cols="12" xl="4" md="4" sm="12">
            <b-img class="image-app-logo" src="../assets/imgs/icon_distanceday_logo.png" fluid alt=""></b-img>
            <span class="image-title">指尖倒数日（一生八指尖倒数日）</span>
          </b-col>
          <b-col class="p-4" cols="12" xl="4" md="4" sm="12">
            <b-img class="image-app-logo" src="../assets/imgs/icon_muyu_logo.png" fluid alt=""></b-img>
            <span class="image-title">指尖木鱼</span>
          </b-col>
          <b-col class="p-4" cols="12" xl="4" md="4" sm="12">
            <b-img class="image-app-logo" src="../assets/imgs/icon_kalinba_logo.png" fluid alt=""></b-img>
            <span class="image-title">电子拇指琴（指尖拇指琴）</span>
          </b-col>
          <b-col class="p-4" cols="12" xl="4" md="4" sm="12">
            <b-img class="image-app-logo" src="../assets/imgs/icon_cooler_logo_n.png" fluid alt=""></b-img>
            <span class="image-title">降温宝（降温测温精灵）</span>
          </b-col>
          <b-col class="p-4" cols="12" xl="4" md="4" sm="12">
            <b-img class="image-app-logo" src="../assets/imgs/icon_curriculum_logo_n.png" fluid alt=""></b-img>
            <span class="image-title">轻记课程表</span>
          </b-col>
          <b-col class="p-4" cols="12" xl="4" md="4" sm="12">
            <b-img class="image-app-logo" src="../assets/imgs/icon_camera_logo_n.png" fluid alt=""></b-img>
            <span class="image-title">美颜拍照相机</span>
          </b-col>
          <b-col class="p-4" cols="12" xl="4" md="4" sm="12">
            <b-img class="image-app-logo" src="../assets/imgs/icon_vedio_logo_n.png" fluid alt=""></b-img>
            <span class="image-title">视频剪辑多多</span>
          </b-col>
          <b-col class="p-4" cols="12" xl="4" md="4" sm="12">
            <b-img class="image-app-logo" src="../assets/imgs/icon_bianpao_logo_n.png" fluid alt=""></b-img>
            <span class="image-title">电子烟花鞭炮</span>
          </b-col>
          <b-col class="p-4" cols="12" xl="4" md="4" sm="12">
            <b-img class="image-app-logo" src="../assets/imgs/icon_qingpai_logo_n.png" fluid alt=""></b-img>
            <span class="image-title">轻拍睡眠</span>
          </b-col>
          <b-col class="p-4" cols="12" xl="4" md="4" sm="12">
            <b-img class="image-app-logo" src="../assets/imgs/icon_acount_logo_n.png" fluid alt=""></b-img>
            <span class="image-title">记账有宝</span>
          </b-col>
          <b-col class="p-4" cols="12" xl="4" md="4" sm="12">
            <b-img class="image-app-logo" src="../assets/imgs/icon_paint_232.png" fluid alt=""></b-img>
            <span class="image-title">绘画精灵</span>
          </b-col>
          <b-col class="p-4" cols="12" xl="4" md="4" sm="12">
            <b-img class="image-app-logo" src="../assets/imgs/icon_pintu_232.png" fluid alt=""></b-img>
            <span class="image-title">拼图精灵（宝宝拼图精灵）</span>
          </b-col>
          <b-col class="p-4" cols="12" xl="4" md="4" sm="12">
            <b-img class="image-app-logo" src="../assets/imgs/icon_tuse_232.png" fluid alt=""></b-img>
            <span class="image-title">涂色精灵（宝宝涂色精灵）</span>
          </b-col>
        </b-row>

        <h2 class="section-title">{{$t('section-title-tools')}}</h2>
        <h3 class="section-sub-title">{{$t('section-sub-title-tools')}}</h3>

        <b-row class="mt-5">
          <b-col class="p-4" cols="12" xl="4" md="4" sm="12">
            <b-img class="image-app-logo" src="../assets/imgs/icon_cooler_logo.png" fluid alt=""></b-img>
            <span class="image-title">{{$t('section-sub-title-tools—cooler')}}</span>
          </b-col>
        </b-row>
        <h3 class="section-sub-title">{{$t('section-sub-title-2')}}</h3>

        <b-row class="mt-5">
<!--          <b-col class="p-4" cols="12" xl="3" md="4" sm="12">-->
<!--            <b-img class="image-app-logo" src="../assets/imgs/icon_healthStep_download_code.png" fluid alt=""></b-img>-->
<!--            <span class="image-title">{{$t('section-2-img-1-title')}}</span>-->
<!--            <p class="image-detail">{{$t('section-2-img-1-p')}}</p>-->
<!--          </b-col>-->
          <b-col class="p-4" cols="12" xl="3" md="4" sm="12">
            <b-img class="image-app-logo" src="../assets/imgs/icon_pedometer_download_code.png" fluid alt=""></b-img>
            <span class="image-title">{{$t('download-study-idiom-title')}}</span>
            <p class="image-detail">{{$t('download-study-idiom-des')}}</p>
          </b-col>
          <b-col class="p-4" cols="12" xl="3" md="4" sm="12">
            <b-img class="image-app-logo" src="../assets/imgs/icon_cooler_code.png" fluid alt=""></b-img>
            <span class="image-title">{{$t('download-study-cooler-title')}}</span>
            <p class="image-detail">{{$t('download-study-cooler-des')}}</p>
          </b-col>
          <b-col class="p-4" cols="12" xl="3" md="4" sm="12">
            <b-img class="image-app-logo" src="../assets/imgs/icon_getup_download_code.png" fluid alt=""></b-img>
            <span class="image-title">{{$t('download-study-cooler-title')}}</span>
            <p class="image-detail">天天早起打卡（指尖早起打卡）Android版</p>
          </b-col>
          <b-col class="p-4" cols="12" xl="3" md="4" sm="12">
            <b-img class="image-app-logo" src="../assets/imgs/icon_sheep_download_code.png" fluid alt=""></b-img>
            <span class="image-title">{{$t('download-study-cooler-title')}}</span>
            <p class="image-detail">天天早睡打卡Android版</p>
          </b-col>
          <b-col class="p-4" cols="12" xl="3" md="4" sm="12">
            <b-img class="image-app-logo" src="../assets/imgs/icon_water_download_code.png" fluid alt=""></b-img>
            <span class="image-title">{{$t('download-study-cooler-title')}}</span>
            <p class="image-detail">每日喝水提醒（指尖喝水提醒）Android版</p>
          </b-col>
          <b-col class="p-4" cols="12" xl="3" md="4" sm="12">
            <b-img class="image-app-logo" src="../assets/imgs/icon_happy_download_code.png" fluid alt=""></b-img>
            <span class="image-title">{{$t('download-study-cooler-title')}}</span>
            <p class="image-detail">开心计步（健身有宝|健身训练）Android版</p>
          </b-col>
          <b-col class="p-4" cols="12" xl="3" md="4" sm="12">
            <b-img class="image-app-logo" src="../assets/imgs/icon_muyu_download_code.png" fluid alt=""></b-img>
            <span class="image-title">{{$t('download-study-cooler-title')}}</span>
            <p class="image-detail">指尖木鱼Android版</p>
          </b-col>
          <b-col class="p-4" cols="12" xl="3" md="4" sm="12">
            <b-img class="image-app-logo" src="../assets/imgs/icon_kalinba_download_code.png" fluid alt=""></b-img>
            <span class="image-title">{{$t('download-study-cooler-title')}}</span>
            <p class="image-detail">电子拇指琴（指尖拇指琴）Android版</p>
          </b-col>
          <b-col class="p-4" cols="12" xl="3" md="4" sm="12">
            <b-img class="image-app-logo" src="../assets/imgs/icon_distanceday_download_code.png" fluid alt=""></b-img>
            <span class="image-title">{{$t('download-study-cooler-title')}}</span>
            <p class="image-detail">指尖倒数日（一生八指尖倒数日）Android版</p>
          </b-col>
          <b-col class="p-4" cols="12" xl="3" md="4" sm="12">
            <b-img class="image-app-logo" src="../assets/imgs/cooler_down_code.png" fluid alt=""></b-img>
            <span class="image-title">{{$t('download-study-cooler-title')}}</span>
            <p class="image-detail"> 降温宝（降温测温精灵）Android版</p>
          </b-col>
          <b-col class="p-4" cols="12" xl="3" md="4" sm="12">
            <b-img class="image-app-logo" src="../assets/imgs/curriculum_down_code.png" fluid alt=""></b-img>
            <span class="image-title">{{$t('download-study-cooler-title')}}</span>
            <p class="image-detail"> 轻记课程表Android版</p>
          </b-col>
          <b-col class="p-4" cols="12" xl="3" md="4" sm="12">
            <b-img class="image-app-logo" src="../assets/imgs/camera_down_code.png" fluid alt=""></b-img>
            <span class="image-title">{{$t('download-study-cooler-title')}}</span>
            <p class="image-detail"> 美颜拍照相机Android版</p>
          </b-col>
          <b-col class="p-4" cols="12" xl="3" md="4" sm="12">
            <b-img class="image-app-logo" src="../assets/imgs/vedio_down_code.png" fluid alt=""></b-img>
            <span class="image-title">{{$t('download-study-cooler-title')}}</span>
            <p class="image-detail"> 视频剪辑多多Android版</p>
          </b-col>
          <b-col class="p-4" cols="12" xl="3" md="4" sm="12">
            <b-img class="image-app-logo" src="../assets/imgs/bianpao_down_code.png" fluid alt=""></b-img>
            <span class="image-title">{{$t('download-study-cooler-title')}}</span>
            <p class="image-detail"> 电子烟花鞭炮Android版</p>
          </b-col>
          <b-col class="p-4" cols="12" xl="3" md="4" sm="12">
            <b-img class="image-app-logo" src="../assets/imgs/qingpai_down_code.png" fluid alt=""></b-img>
            <span class="image-title">{{$t('download-study-cooler-title')}}</span>
            <p class="image-detail"> 轻拍睡眠Android版</p>
          </b-col>
          <b-col class="p-4" cols="12" xl="3" md="4" sm="12">
            <b-img class="image-app-logo" src="../assets/imgs/acount_down_code.png" fluid alt=""></b-img>
            <span class="image-title">{{$t('download-study-cooler-title')}}</span>
            <p class="image-detail"> 记账有宝Android版</p>
          </b-col>
          <b-col class="p-4" cols="12" xl="3" md="4" sm="12">
            <b-img class="image-app-logo" src="../assets/imgs/paint_down_code.png" fluid alt=""></b-img>
            <span class="image-title">{{$t('download-study-cooler-title')}}</span>
            <p class="image-detail"> 绘画精灵Android版</p>
          </b-col>
          <b-col class="p-4" cols="12" xl="3" md="4" sm="12">
            <b-img class="image-app-logo" src="../assets/imgs/pintu_down_code.png" fluid alt=""></b-img>
            <span class="image-title">{{$t('download-study-cooler-title')}}</span>
            <p class="image-detail"> 拼图精灵（宝宝拼图精灵）Android版</p>
          </b-col>
          <b-col class="p-4" cols="12" xl="3" md="4" sm="12">
            <b-img class="image-app-logo" src="../assets/imgs/tuse_down_code.png" fluid alt=""></b-img>
            <span class="image-title">{{$t('download-study-cooler-title')}}</span>
            <p class="image-detail"> 涂色精灵（宝宝涂色精灵）Android版</p>
          </b-col>
<!--          <b-col class="p-4" cols="12" xl="3" md="4" sm="12">-->
<!--            <b-img class="image-app-logo" src="../assets/imgs/icon_leStep_logo.png" fluid alt=""></b-img>-->
<!--            <span class="image-title">{{$t('section-2-img-2-title')}}</span>-->
<!--            <p class="image-detail">{{$t('section-2-img-2-p')}}</p>-->
<!--          </b-col>-->
<!--          <b-col class="p-4" cols="12" xl="3" md="4" sm="12">-->
<!--            <b-img class="image-app-logo" src="../assets/imgs/icon_healthStep_logo.png" fluid alt=""></b-img>-->
<!--            <span class="image-title">{{$t('section-2-img-3-title')}}</span>-->
<!--            <p class="image-detail">{{$t('section-2-img-3-p')}}</p>-->
<!--          </b-col>-->
<!--          <b-col class="p-4" cols="12" xl="3" md="4" sm="12">-->
<!--            <b-img class="image-app-logo" src="../assets/imgs/icon_leStep_logo.png" fluid alt=""></b-img>-->
<!--            <span class="image-title">{{$t('section-2-img-3-title')}}</span>-->
<!--            <p class="image-detail">{{$t('section-2-img-3-p')}}</p>-->
<!--          </b-col>-->
        </b-row>

      </b-container>

      <!--PC端展示-->
<!--      <b-container v-if="!isMobile" fluid="xl" class="section-2">-->
<!--        <h2 class="section-title">{{$t('section-title-2')}}</h2>-->

<!--        <b-row style="margin-top: 60px">-->
<!--          <b-col>-->
<!--            <b-img src="../assets/imgs/home-section-2-img-1.png" fluid></b-img>-->
<!--          </b-col>-->
<!--          <b-col cols="1"></b-col>-->
<!--          <b-col class="row-content" style="text-align: left">-->
<!--            <h5 class="row-title">{{$t('section-2-row-1-title')}}</h5>-->
<!--            <p class="row-detail" v-html="$t('section-2-row-1-detail')"></p>-->
<!--          </b-col>-->
<!--        </b-row>-->

<!--        <b-row style="margin-top: 120px">-->
<!--          <b-col class="row-content" style=" text-align: right;">-->
<!--            <h5 class="row-title">{{$t('section-2-row-2-title')}}</h5>-->
<!--            <p class="row-detail" v-html="$t('section-2-row-2-detail')"></p>-->
<!--          </b-col>-->
<!--          <b-col cols="1"></b-col>-->
<!--          <b-col>-->
<!--            <b-img src="../assets/imgs/home-section-2-img-2.png" fluid></b-img>-->
<!--          </b-col>-->
<!--        </b-row>-->

<!--        <b-row style="margin-top: 134px">-->
<!--          <b-col style="text-align: right">-->
<!--            <b-img src="../assets/imgs/home-section-2-img-3.png" fluid></b-img>-->
<!--          </b-col>-->
<!--          <b-col cols="1"></b-col>-->
<!--          <b-col class="row-content" style="text-align: left">-->
<!--            <h5 class="row-title">{{$t('section-2-row-3-title')}}</h5>-->
<!--            <p class="row-detail" v-html="$t('section-2-row-3-detail')"></p>-->
<!--          </b-col>-->
<!--        </b-row>-->
<!--      </b-container>-->
      <!--手机端展示-->
<!--      <b-container v-else class="section-2">-->

<!--        <h2 class="section-title">{{$t('section-title-2')}}</h2>-->

<!--        <b-row style="margin-top: 60px">-->
<!--          <b-col cols="12" class="text-center">-->
<!--            <b-img src="../assets/imgs/home-section-2-img-1.png" style="width: 80%;" fluid></b-img>-->
<!--          </b-col>-->
<!--          <b-col class="row-content mt-5" style="text-align: center">-->
<!--            <h5 class="row-title">{{$t('section-2-row-1-title')}}</h5>-->
<!--            <p class="row-detail" v-html="$t('section-2-row-1-detail')"></p>-->
<!--          </b-col>-->
<!--        </b-row>-->

<!--        <b-row style="margin-top: 120px">-->
<!--          <b-col cols="12" class="text-center">-->
<!--            <b-img src="../assets/imgs/home-section-2-img-2.png" style="width: 80%;" fluid></b-img>-->
<!--          </b-col>-->
<!--          <b-col class="row-content mt-5" style=" text-align: center;">-->
<!--            <h5 class="row-title">{{$t('section-2-row-2-title')}}</h5>-->
<!--            <p class="row-detail" v-html="$t('section-2-row-2-detail')"></p>-->
<!--          </b-col>-->
<!--        </b-row>-->

<!--        <b-row style="margin-top: 134px">-->
<!--          <b-col cols="12" class="text-center">-->
<!--            <b-img src="../assets/imgs/home-section-2-img-3.png" style="width: 80%;" fluid></b-img>-->
<!--          </b-col>-->
<!--          <b-col class="row-content mt-5" style="text-align: center">-->
<!--            <h5 class="row-title">{{$t('section-2-row-3-title')}}</h5>-->
<!--            <p class="row-detail" v-html="$t('section-2-row-3-detail')"></p>-->
<!--          </b-col>-->
<!--        </b-row>-->

<!--      </b-container>-->
    </main>
  </div>
</template>

<script>
import HeaderStyle1 from '../components/HeaderStyles1.vue'
import runtime from '../utils/runtime'

export default {
  name: 'Home',
  components: {
    HeaderStyle1
  },
  data () {
    return {
      isMobile: runtime.isMobile()
    }
  },
  mounted () {
    document.title = '首页'
  }
}
</script>
<style lang="scss" scoped>
  .home {
    .main-content {
      margin-top: 80px;
      padding-bottom: 100px;

      .section-title {
        font-size: 34px;
        font-weight: 700;
        color: #000000;
      }

      .section-sub-title {
        font-size: 24px;
        font-weight: 400;
        color: #000000;
        line-height: 1.4;
        margin-top: 25px;
      }

      .image-title {
        display: block;
        font-size: 24px;
        font-weight: 700;
        text-align: center;
        color: #000000;
        margin-top: 24px;
      }
      .p-4{
        display: flex;
        flex-direction: column;
        align-items: center;
      }
      .image-app-logo{

      }

      .image-detail {
        font-size: 16px;
        font-weight: 400;
        text-align: center;
        color: #000000;
        line-height: 20px;
        margin-top: 24px;
      }

      .section-1{

      }
      .mt-5{
        margin-top: 10px !important;
        margin-top: 10px !important;
      }
      .section-2{
        margin-top: 113px;

        .row-content {
          display: flex;
          flex-direction: column;
          justify-content: flex-end;

          .row-title {
            font-size: 24px;
            font-weight: 700;
            color: #000000;
          }

          .row-detail {
            font-size: 18px;
            font-weight: 400;
            color: #000000;
            line-height: 1.4;
            margin-top: 31px;
          }
        }
      }
    }

  }
</style>
<style scoped lang="scss">
  @media (max-width: 768px) {
    .row-title {
      font-size: 20px !important;
    }
    .row-detail {
      font-size: 16px !important;
      margin-top: 10px !important;
    }
    .main-content {
      margin-top: 33px !important;
    }
    .section-title {
      font-size: 20px !important;
      text-align: center;
    }
    .section-sub-title {
      font-size: 12px !important;
      text-align: center;
    }
    .image-title {
      font-size: 14px !important;
      margin-top: 24px;
    }
    .image-detail {
      font-size: 12px !important;
      margin-top: 24px;
    }
  }
</style>
